export default __webpack_public_path__ + "static/media/player-settings-icon.11d34cbf.svg";